var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0H4C1.79086 0 0 1.79086 0 4V36C0 38.2091 1.79086 40 4 40H28C30.2091 40 32 38.2091 32 36V4C32 1.79086 30.2091 0 28 0ZM2 4C2 2.89543 2.89543 2 4 2H28C29.1046 2 30 2.89543 30 4V36C30 37.1046 29.1046 38 28 38H4C2.89543 38 2 37.1046 2 36V4ZM16 36C17.1046 36 18 35.1046 18 34C18 32.8954 17.1046 32 16 32C14.8954 32 14 32.8954 14 34C14 35.1046 14.8954 36 16 36Z",
    fill: "#50B247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.9a1a3633245bb75ccf41b9b9b857c661.svg";
export { ForwardRef as ReactComponent };